import React from 'react';
import Tabs from '../../../Global/Tabs';
import {formatAsOrdinal} from '../../../../services/util';
import { tooltipTypes, Tooltip } from '../../../Global/Tooltip';
import { hasTimedOut } from '../../../../services/teacher/recentTeacherSelections';

/**
 * Specific to Daignostic report
 */
export default class DomainTabs extends React.Component {
  constructor (props){
    super(props);
    this.state = {
      currentTabId: this.getDefaultTab()
    }

    this.reportTabChange = this.reportTabChange.bind(this)
  }

  componentWillUnmount(){
    /**
     * Save current tab to cache, will be used on the next render as default opened tab index.
     */
    sessionStorage.setItem('diagnosticActiveTab', JSON.stringify({
      timestamp: new Date(),
      selectedTab: this.state.currentTabId,
    }));
  }

  /**
   * Returns a tab index for the default tab to be opened, check cache otherwise, 0.
   * @returns {number} tab index
   */
  getDefaultTab(){
    // TODO (DONE): AE-3440 was the cleanup ticket
    const cachedTab = sessionStorage.getItem('diagnosticActiveTab');
    if(cachedTab && !hasTimedOut(cachedTab, 'diagnosticActiveTab')) {
      const defaultTab = JSON.parse(cachedTab).selectedTab;
      if(this.props.tabs && this.props.tabs.length > defaultTab) {
        return defaultTab
      }
    }
    return 0
  }

  /**
   * Update currentTab state
   * @param {number} index 
   */
   reportTabChange(index){
    this.setState({currentTabId: index})
  }

  getPercentageLabel(rawPercentage, label){
    let tooltip = this.getLabelTooltip(label);
    let percentage = rawPercentage && Math.round(rawPercentage);
    if(percentage){
      if(percentage > 100){
        percentage = 100;
      }
      let dynamicWidthStyle = {
        width: percentage + "%",
      };
      let progressBarClass = "progressBar";
      let percentageClass = "percentage";
      if(this.props.cutoffs && this.props.cutoffs.okay && this.props.cutoffs.good) {
        if(percentage < this.props.cutoffs.okay){
          progressBarClass += " bad";
          percentageClass += " bad";
        }else if(percentage > this.props.cutoffs.good){
          progressBarClass += " good";
        } else {
          progressBarClass += " okay";
        }
      }
      return(
        <div className="percentageLabel">
          <div className="label">{label}{tooltip}</div>
          <div className={percentageClass}>{formatAsOrdinal(percentage)}</div>
          <div className="units">percentile</div>
          <div className="progressBarContainer">
            <div className={progressBarClass} style={dynamicWidthStyle}/>
          </div>
        </div>
      );
    } else {
      return(
        <div className="percentageLabel">
          <div className="label">{label}{tooltip}</div>
        </div>
      );
    }
  }

  formatPercentageLabels(){
    return this.props.tabs.map((tab)=> {
      let percentage = tab.tab && tab.tab.percentage;
      let label = tab.tab && tab.tab.label;
      return({
        tab: this.getPercentageLabel(percentage, label),
        content: tab.content,
      });
    });
  }

  getLabelTooltip(label) {
    switch (label) {
      case 'Phonological Awareness':
        return (
          <Tooltip type={tooltipTypes.phonologicalAwareness} />
        )
      case 'High Frequency Words':
        return (
          <Tooltip type={tooltipTypes.sightRecognition} />
        )
      case 'Vocabulary':
        return (
          <Tooltip type={tooltipTypes.vocabulary} />
        )
      case 'Decoding':
        return (
          <Tooltip type={tooltipTypes.decoding} />
        )
    }
  }

  render() {
    let tabs = this.formatPercentageLabels();
    return (
      <Tabs tabs={tabs} scrollable={true} defaultTab={this.state.currentTabId} reportTabChange={this.reportTabChange}/>
    );
  }
}

